import {App} from 'vue';
import { init } from '@plausible-analytics/tracker'

export default {
    install(app: App, options) {
        init({
            domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN,
            outboundLinks: true,
            fileDownloads: true,
        });
    }
}
